export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.45.0-30c130124.svg#instagram-flat","viewBox":"0 0 512.001 512.001"}